import {
    normalizeReportFinanceCommissionItem,
    normalizeReportFinanceCommissionListTotals,
} from '@utils/storeDataNormalization';
import { storeConstants } from '@utils/constants';
import storeModuleFactory from '@helpers/storeModuleFactory';
import { mutationTypes } from '@helpers/storeFactories/helpers';
import { apiService } from '@api';

const STORE_NAME = 'financeCommission';

const store = storeModuleFactory.createModuleView(
    STORE_NAME,
    {
        get: apiService.reports.financeCommission.get,
    },
    {
        actionGetOptionsDefault: {
            refresh: false,
            offset: 0,
            limit: storeConstants.ITEMS_PER_PAGE,
        },
    },
    {
        state: {
            filters: {},
        },
        getters: {
            filters: (state) => state.filters,
            total: (state) => state.totalCount,
            reportTotals: (state) => normalizeReportFinanceCommissionListTotals(state.totals),
        },
        mutations: {
            [mutationTypes.APPEND_TO_LIST](state, pageData) {
                state.timestamp = new Date().getTime();
                state.list = [
                    ...state.list,
                    ...pageData.map(normalizeReportFinanceCommissionItem).flat(),
                ];
            },
            [mutationTypes.UPDATE_FILTERS](state, { filters }) {
                state.filters = filters;
            },
            [mutationTypes.CLEAR_DATA](state) {
                state.list = [];
                state.totalCount = 0;
                state.loading = 0;
                state.allItemsLoaded = false;
                state.refresh = false;
                state.detail = {};
                state.totals = null;
                state.filters = {};
            },
        },
        actions: {
            async updateFilters({ commit }, { filters }) {
                return commit(mutationTypes.UPDATE_FILTERS, { filters });
            },
        },
    }
);

export default store;
